<template>
  <page-component
    id="websiterentals"
    :header="`${locationdescription}`">
    <commentcard-component
      v-if="locationcomment"
      id="websiterentals-commentcard"
      commentTitle="Information"
      :commentImage="locationimage"
      :commentText="locationcomment"
      :commentCount="sites.length + ' ' + sitelabel + 's'"
      :commentDesc="locationdescription">
    </commentcard-component>
    <div
      ref="filterGroup"
      class="group filter-group collapse hidden"
      :class="{ mobile: primaryState === 'mobile' }"
      id="websiterentals-filters-group"
      v-if="
        filters.class.options.length > 1 ||
        filters.type.options.length !== 0 ||
        filters.category.options.length !== 0 ||
        filters.features.options.length !== 0 ||
        filters.loop.options.length !== 0
      ">
      <h2
        class="header group__header"
        :class="{ hidden: hasMap && mapOpen }">
        <button
          class="collapse-icon valid"
          type="button"
          aria-expanded="false">
          <span class="ui-icon ui-icon-triangle-1-s"
            >Hide/Show Group Contents</span
          >
        </button>
        <span class="header__text"
          >Search Criteria
          <span
            class="filter-group-count"
            v-if="primaryState === 'mobile'"
            >{{ noActiveFilters }}</span
          >
        </span>
      </h2>
      <div class="rect group__inner">
        <div id="websiterentals-filters">
          <div
            class="newline search-criteria newline-combobox"
            v-if="filters.class.options.length > 1">
            <label
              id="websiterentals-class-filter_label"
              for="websiterentals-class-filter_label"
              >{{ rentalclasslabel }}</label
            >
            <div class="field-wrap combobox-field-wrap">
              <combobox-component
                id="websiterentals-class-filter"
                :disabled="processing"
                displayStyle="list"
                :multiple="true"
                emptyLabel="All Rental Classes"
                :items="filters.class.options"
                v-model="filters.class.values"
                @change="onFilterChange()">
              </combobox-component>
            </div>
          </div>
          <div
            class="newline search-criteria newline-combobox"
            v-if="filters.loop.options.length !== 0">
            <label
              id="websiterentals-loop-filter_label"
              for="websiterentals-loop-filter_label"
              >{{ looplabel }}</label
            >
            <div class="field-wrap combobox-field-wrap">
              <combobox-component
                id="websiterentals-loop-filter"
                :disabled="processing"
                displayStyle="list"
                :multiple="true"
                emptyLabel="All Loops"
                :items="filters.loop.options"
                v-model="filters.loop.values"
                @change="onFilterChange()">
              </combobox-component>
            </div>
          </div>
          <div
            class="newline search-criteria newline-combobox"
            v-if="filters.type.options.length !== 0">
            <label
              id="websiterentals-type-filter_label"
              for="websiterentals-type-filter_label"
              >{{ typelabel }}</label
            >
            <div class="field-wrap combobox-field-wrap">
              <combobox-component
                id="websiterentals-type-filter"
                :disabled="processing"
                displayStyle="list"
                :multiple="true"
                emptyLabel="All Types"
                :items="filters.type.options"
                v-model="filters.type.values"
                @change="onFilterChange()">
              </combobox-component>
            </div>
          </div>
          <div
            class="newline search-criteria newline-combobox"
            v-if="filters.category.options.length !== 0">
            <label
              id="websiterentals-category-filter_label"
              for="websiterentals-category-filter_label"
              >{{ categorylabel }}</label
            >
            <div class="field-wrap combobox-field-wrap">
              <combobox-component
                id="websiterentals-category-filter"
                :disabled="processing"
                displayStyle="list"
                :multiple="true"
                emptyLabel="All Categories"
                :items="filters.category.options"
                v-model="filters.category.values"
                @change="onFilterChange()">
              </combobox-component>
            </div>
          </div>
          <div
            class="newline search-criteria newline-combobox"
            v-if="filters.features.options.length !== 0">
            <label
              id="websiterentals-features-filter_label"
              for="websiterentals-features-filter_label"
              >{{ featureslabel }}</label
            >
            <div class="field-wrap combobox-field-wrap">
              <combobox-component
                id="websiterentals-features-filter"
                :disabled="processing"
                displayStyle="list"
                :multiple="true"
                emptyLabel="All Features"
                :items="filters.features.options"
                v-model="filters.features.values"
                @change="onFilterChange()">
              </combobox-component>
            </div>
          </div>
          <div
            class="newline"
            style="height: 40px"
            v-if="primaryState === 'mobile'"></div>
        </div>
        <button
          v-if="primaryState === 'mobile'"
          class="button instant-overlay primary filter-group-search"
          id="websiterentals-filter-button-search"
          @click.prevent="onMobileSearch(false)">
          Search
        </button>
        <button
          v-if="primaryState === 'mobile'"
          class="button tertiary filter-group-reset"
          id="websiterentals-filter-button-reset"
          @click.prevent="onMobileReset(false)">
          Reset
        </button>
      </div>
    </div>
    <group-component
      header=""
      :class="{ mobileGroup: primaryState === 'mobile' }">
      <div
        id="websiterentals-grid"
        :class="{ expanded: !hasMap || !mapOpen }">
        <div id="websiterentals-controls">
          <div
            id="websiterentals-controls-top"
            :class="{ extendHeight: extendHeight }">
            <div id="websiterentals-controls-top-left">
              <datepicker-component
                id="websiterentals-checkindate"
                label="Check-In Date"
                :disabled="processing"
                :minDate="currentDate"
                :modelValue="displayedCheckInDate"
                @change="onCheckInDate($event)">
              </datepicker-component>
              <datepicker-component
                id="websiterentals-checkoutdate"
                label="Check-Out Date"
                :disabled="processing"
                :minDate="currentDate"
                :maxDate="maxdate"
                :openRight="true"
                :modelValue="displayedCheckOutDate"
                @change="onCheckOutDate($event)">
              </datepicker-component>
              <div
                id="websiterentals-wordsearch_wrap"
                class="fillin-wrap"
                :class="{ extendHeight: extendHeight }">
                <label
                  id="websiterentals-wordsearch_label"
                  for="websiterentals-wordsearch_input"
                  class="fillin-label"
                  >Search {{ sitelabel }}</label
                >
                <input
                  id="websiterentals-wordsearch_input"
                  class="fillin"
                  autocomplete="off"
                  type="text"
                  v-model="keywordSearch"
                  @input="onSearch(false)"
                  max-length="100" />
              </div>
            </div>
            <div id="websiterentals-controls-top-right">
              <button
                v-if="hasMap && mapOpen"
                id="websiterentals-expand"
                type="button"
                class="button"
                :class="{ extendHeight: extendHeight }"
                aria-label="Expand"
                :disabled="processing"
                @click.prevent="onExpand()">
                <div class="icon">
                  <span>
                    <svgicon
                      aria-hidden="true"
                      original
                      data="@iconPath/glyph/16/expand.svg?inline"
                      width="16"
                      height="16"></svgicon>
                  </span>
                </div>
                Expand
              </button>
              <button
                v-else-if="hasMap && !mapOpen"
                id="websiterentals-condense"
                type="button"
                class="button"
                aria-label="Condense"
                :disabled="!hasMap || processing"
                @click.prevent="onExpand()">
                <div class="icon">
                  <span>
                    <svgicon
                      aria-hidden="true"
                      original
                      data="@iconPath/glyph/16/condense.svg?inline"
                      width="16"
                      height="16"></svgicon>
                  </span>
                </div>
                Condense
              </button>
            </div>
          </div>
          <div id="websiterentals-controls-bottom">
            <div id="websiterentals-controls-left">
              <button
                id="websiterentals-refresh"
                type="button"
                class="button"
                aria-label="Refresh"
                :disabled="processing"
                @click.prevent="onRefresh()">
                <div class="icon">
                  <span>
                    <svgicon
                      aria-hidden="true"
                      original
                      data="@iconPath/glyph/16/refresh.svg?inline"
                      width="16"
                      height="16"></svgicon>
                  </span>
                </div>
                Refresh
              </button>
            </div>
            <div id="websiterentals-controls-right">
              <button
                id="websiterentals-prevweek"
                type="button"
                class="button primary"
                :aria-label="'Previous ' + daysToMove + ' Days'"
                :disabled="processing"
                @click.prevent="onPrevNext(-1 * daysToMove)">
                Prev {{ daysToMove }} Days
              </button>
              <button
                id="websiterentals-nextweek"
                type="button"
                class="button primary"
                :aria-label="'Next ' + daysToMove + ' Days'"
                :disabled="processing"
                @click.prevent="onPrevNext(daysToMove)">
                Next {{ daysToMove }} Days
              </button>
            </div>
          </div>
        </div>
        <div
          id="websiterentals-table-scroll"
          ref="tableScroll">
          <div
            id="websiterentals-table-wrapper"
            ref="tableWrapper"
            @scroll="onScroll()">
            <table
              id="websiterentals-table"
              class="rental-calendar-table">
              <caption class="sr-only">
                {{
                  sitelabel
                }}
                availability calendar for
                {{
                  locationdescription
                }}
                from
                {{
                  displayedDates[0].descDayLong
                }}
                {{
                  monthColumns[0].long
                }}
                {{
                  displayedDates[0].descDate
                }}
                to
                {{
                  displayedDates[displayedDates.length - 1].descDayLong
                }}
                {{
                  monthColumns[monthColumns.length - 1].long
                }}
                {{
                  displayedDates[displayedDates.length - 1].descDate
                }}
              </caption>
              <thead ref="tableHead">
                <tr>
                  <th
                    role="presentation"
                    :class="{
                      blank: true,
                      mobileMap: primaryState === 'mobile'
                    }"
                    colspan="1"></th>
                  <th
                    v-for="column in monthColumns"
                    :key="column.desc"
                    :colspan="column.span"
                    class="month"
                    role="presentation">
                    {{ column.desc }}
                  </th>
                </tr>
                <tr>
                  <th
                    class="primary"
                    scope="col"
                    :aria-sort="
                      sortOption === 'codeascending'
                        ? 'ascending'
                        : sortOption === 'codedescending'
                        ? 'descending'
                        : null
                    ">
                    <button
                      id="websiterentals-sortcode"
                      type="button"
                      :class="{
                        ascending: sortOption === 'codeascending',
                        descending: sortOption === 'codedescending'
                      }"
                      :aria-label="sitelabel"
                      @click.prevent="onSort('code')">
                      {{ sitelabel }}
                    </button>
                  </th>
                  <th
                    v-for="(day, column) in displayedDates"
                    :key="day.dateString"
                    class="day"
                    scope="col"
                    :aria-sort="
                      sortOption === column + 'ascending'
                        ? 'ascending'
                        : sortOption === column + 'descending'
                        ? 'descending'
                        : null
                    ">
                    <button
                      :id="'websiterentals-sort' + column"
                      type="button"
                      :class="{
                        ascending: sortOption === column + 'ascending',
                        descending: sortOption === column + 'descending'
                      }"
                      :aria-label="
                        day.descDayLong +
                        ' ' +
                        day.descMonth +
                        ' ' +
                        day.descDate
                      "
                      @click.prevent="onSort(column)">
                      {{ day.descDay }} <br />
                      {{ day.descDate }}
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody v-if="filteredSites.length != 0">
                <tr
                  v-for="site in resultsSorted"
                  :key="site.siteId"
                  ref="tableRow"
                  :id="'websiterentals-site' + site.siteId"
                  @mouseover="onMouseOverSite(site.siteId)"
                  @mouseout="onMouseOutSite(site.siteId)"
                  :disabled="processing">
                  <th
                    class="site-cell primary info-cell"
                    scope="row">
                    <button
                      :id="'websiterentals-site-button-code-' + site.siteId"
                      type="button"
                      class="primary"
                      :aria-label="site.siteCode"
                      v-tooltip="{ text: site.siteCode}"
                      :class="{ selected: site.beginDate , 'has-tooltip': true}"
                      @click.prevent="onClickCode(site)">
                      <span>{{ site.siteCode }}</span>
                    </button>
                    <a
                      :id="'websiterentals-site-details-' + site.siteId"
                      :href="
                        baseHref +
                        'iteminfo.html?Module=RN&FMID=' +
                        site.siteId +
                        (checkInDate !== null
                          ? '&CheckInDate=' + checkInDate
                          : '') +
                        (checkOutDate !== null
                          ? '&CheckOutDate=' + checkOutDate
                          : '')
                      "
                      :aria-label="'Additional Details for ' + site.siteCode">
                    </a>
                  </th>
                  <td
                    v-if="site.dates.length !== displayedDates.length"
                    aria-label="Loading Results"
                    :colspan="daysToShow">
                    Loading Results
                  </td>
                  <div
                    v-else
                    class="day-container">
                    <td
                      v-for="(day, column) in displayedDates"
                      :key="day.dateString"
                      :id="
                        'websiterentals-site-' + site.siteId + '-day-' + column
                      ">
                      <button
                        :id="
                          'websiterentals-site-button-' +
                          site.siteId +
                          '-day-' +
                          column
                        "
                        type="button"
                        :aria-label="
                          site.dates[column].dateString +
                          ' - Site ' +
                          site.siteCode +
                          ' is ' +
                          (day && site.endDate === day.dateTime
                            ? 'Selected - Click to remove selection'
                            : day &&
                              site.beginDate <= day.dateTime &&
                              site.endDate > day.dateTime
                            ? 'Selected'
                            : site.dates[column].status === 'A'
                            ? 'Available'
                            : site.dates[column].status === 'U'
                            ? 'Unavailable'
                            : 'Reserved')
                        "
                        :class="{
                          day: true,
                          available: site.dates[column].status === 'A',
                          unavailable: site.dates[column].status === 'U',
                          reserved: site.dates[column].status === 'R',
                          selected:
                            day &&
                            site.beginDate <= day.dateTime &&
                            site.endDate >= day.dateTime,
                          begin: day && site.beginDate === day.dateTime,
                          end: day && site.endDate === day.dateTime
                        }"
                        @click.prevent="onClickGrid(site, column)">
                        {{ site.dates[column].status }}
                        <div
                          v-if="day && site.endDate === day.dateTime"
                          class="icon">
                          <span>
                            <svgicon
                              original
                              data="@iconPath/glyph/12/close.svg?inline"
                              width="10"
                              height="10"></svgicon>
                          </span>
                        </div>
                      </button>
                    </td>
                  </div>
                </tr>
              </tbody>
            </table>
            <div
              id="websiterentals-empty-message"
              v-if="filteredSites.length == 0">
              There are no rental sites available based on the filters.
            </div>
          </div>
          <button
            id="websiterentals-table-top-button"
            class="button primary"
            v-if="filteredSites.length > recordsToShow"
            @click.prevent="scrollTop()">
            <span>Top</span>
          </button>
          <teleport to="#app">
            <form
              ref="form"
              id="websiterentals-form"
              class="novalidate"
              :action="baseHref + 'addtocart.html?ProcessMultiSelect=yes'"
              method="post"
              @submit.prevent="submitForm()">
              <input
                type="hidden"
                name="Action"
                value="" />
              <input
                type="hidden"
                name="SubAction"
                value="" />
              <input
                type="hidden"
                name="_csrf_token"
                :value="csrf" />
              <input
                type="hidden"
                name="Module"
                value="RN" />
              <input
                type="hidden"
                name="FromProgram"
                value="siterentals" />
              <input
                type="hidden"
                name="PreviousSearch"
                :value="'location=' + rentallocation" />
              <multiselectlist-component
                id="websiterentals-multiselectlist"
                :disabled="processing || selections.length === 0"
                v-model="selections"
                :descriptions="descriptions"
                :selectionChangeMessage="selectionChangeMessage"
                @change="clearSelections()"
                @submitForm="submitForm()">
              </multiselectlist-component>
            </form>
          </teleport>
        </div>
      </div>
      <div
        id="websiterentals-map"
        v-if="hasMap"
        :class="{
          mobileMap: primaryState === 'mobile',
          selected: selections.length > 0,
          visible: mapOpen,
          extendHeight: extendHeight
        }"></div>
      <div
        v-if="hasMap && primaryState === 'mobile'"
        :class="{ mobile: primaryState === 'mobile' }">
        <button
          id="websiterentals-map-button"
          :class="{ mapButton: true, selected: selections.length > 0 }"
          v-if="!mapOpen"
          :disabled="processing"
          @click.prevent="openMap()">
          <div class="icon">
            <span
              ><svgicon
                original
                data="@iconPath/glyph/24/location_pin.svg?inline"
                width="24"
                height="24"></svgicon
            ></span>
          </div>
          Map
        </button>
        <button
          id="websiterentals-calendar-button"
          :class="{ mapButton: true, selected: selections.length > 0 }"
          v-else
          :disabled="processing"
          @click.prevent="openMap()">
          <div
            class="icon"
            style="margin-right: 4px">
            <span
              ><svgicon
                original
                data="@iconPath/glyph/24/calendar-date-2.svg?inline"
                width="24"
                height="24"></svgicon
            ></span>
          </div>
          Calendar
        </button>
        <button
          id="websiterentals-close-button"
          class="mapButtonClose"
          v-if="mapOpen"
          :disabled="processing"
          @click.prevent="openMap()">
          <div class="icon">
            <span
              ><svgicon
                original
                data="@iconPath/glyph/12/close.svg?inline"
                width="12"
                height="12"></svgicon
            ></span>
          </div>
        </button>
      </div>
    </group-component>
  </page-component>
</template>

<script>
import { getFormattedDate } from '@/mixins/utils'
import { siteRentals } from '@/mixins/siteRentals'
import mapboxgl from 'mapbox-gl'
import Tooltip from '@/directives/tooltip'

let map = null
let fullScreenControl = null
let highlightedSite = null
let config = {
  maxMobileWidth: 550,
  maxTabletWidth: 990,
  mobileSmall: {
    daysToShow: 5,
    daysToMove: 4
  },
  mobileBig: {
    daysToShow: 7,
    daysToMove: 5
  },
  desktopCondense: {
    daysToShow: 14,
    daysToMove: 7
  },
  desktopExpand: {
    daysToShow: 28,
    daysToMove: 14
  }
}

export default {
  name: 'SiteRentals',
  props: {
    rentallocation: String,
    locationcomment: String,
    locationdescription: String,
    locationimage: String,
    startdate: String,
    maxdate: String,
    rentalclass: String,
    rentaltype: String,
    rentalcategory: String,
    rentalfeatures: String,
    rentalsiteloop: [String, Number],
    rentalsite: String,
    sitelabel: String,
    looplabel: String,
    rentalclasslabel: String,
    typelabel: String,
    categorylabel: String,
    featureslabel: String,
    sites: Array,
    locationcoordinates: String,
    initselectionstate: String,
    mapzoomlevel: [String, Number]
  },
  directives: {
    Tooltip
  },
  mixins: [getFormattedDate, siteRentals],
  data() {
    return {
      csrf: App.settings.CSRFToken,
      baseHref: App.settings.BaseHref,
      imagePath: App.settings.ImagePath,
      beginDate: null,
      currentDate: null,
      primaryState: null,
      secondaryState: null,
      mapOpen: false,
      hasMap: false,
      extendHeight: false,
      size: null,
      daysToShow: 0,
      daysToMove: 0,
      recordsToShow: 10,
      keywordSearch: '',
      updateSource: null,
      monthColumns: [],
      sortOption: 'codeascending',
      noActiveFilters: 0,
      filters: {
        location: {
          options: [],
          values: []
        },
        class: {
          options: [],
          values: []
        },
        type: {
          options: [],
          values: []
        },
        category: {
          options: [],
          values: []
        },
        features: {
          options: [],
          values: []
        },
        loop: {
          options: [],
          values: []
        }
      }
    }
  },
  computed: {
    resultsSorted() {
      const sortedSites = this.filteredSites
      const column = parseInt(this.sortOption)

      return sortedSites.sort((a, b) => {
        if (this.sortOption === 'loopascending') {
          if (a.siteLoop == b.siteLoop) return 0
          if (a.siteLoop > b.siteLoop) return 1
          if (a.siteLoop < b.siteLoop) return -1
        } else if (this.sortOption === 'loopdescending') {
          if (a.siteLoop == b.siteLoop) return 0
          if (a.siteLoop < b.siteLoop) return 1
          if (a.siteLoop > b.siteLoop) return -1
        } else if (this.sortOption === 'codedescending') {
          if (a.siteCode == b.siteCode) return 0
          if (a.siteCode < b.siteCode) return 1
          if (a.siteCode > b.siteCode) return -1
        } else if (this.sortOption === 'codeascending') {
          if (a.siteCode == b.siteCode) return 0
          if (a.siteCode > b.siteCode) return 1
          if (a.siteCode < b.siteCode) return -1
        } else if (!isNaN(column) && column <= this.daysToShow - 1) {
          if (this.sortOption.endsWith('descending')) {
            if (a.dates[column].status == b.dates[column].status) return 0
            if (a.dates[column].status < b.dates[column].status) return 1
            if (a.dates[column].status > b.dates[column].status) return -1
          } else {
            if (a.dates[column].status == b.dates[column].status) return 0
            if (a.dates[column].status > b.dates[column].status) return 1
            if (a.dates[column].status < b.dates[column].status) return -1
          }
        }
      })
    }
  },
  created() {
    let arrR

    this.initLayoutConfig()

    window.addEventListener('resize', this.onResizeWindow)
    document.addEventListener('orientationchange', this.onResizeWindow)
    document.addEventListener('touchstart', this.removeHighlight)

    this.keywordSearch = this.rentalsite.toString()
    this.beginDate = this.startdate
    this.currentDate = getFormattedDate(new Date())

    if (new Date(this.beginDate) < new Date(this.currentDate)) {
      this.beginDate = this.currentDate
    }

    let cookie = this.getSiteRentalsCookie()
    if (cookie == null) {
      this.setSiteRentalsCookie()
    } else {
      this.checkInDate = cookie[1]
      this.displayedCheckInDate = this.checkInDate
      this.checkOutDate = cookie[2]
      this.displayedCheckOutDate = this.checkOutDate
      if (new Date(this.startdate) < new Date(this.currentDate)) {
        this.beginDate = cookie[0]
      } else {
        this.setSiteRentalsCookie()
      }
    }

    this.initSelections()

    this.sites.forEach((site) => {
      site.beginTimeIntList = site.beginTimeIntList.split(',')
      site.endTimeIntList = site.endTimeIntList.split(',')

      if (site.siteClass != '') {
        arrR = this.filters.class.options.filter(function (ele) {
          return ele.value == site.siteClass
        })

        if (!arrR.length) {
          this.filters.class.options.push({
            label: site.siteClassDesc,
            value: site.siteClass
          })
        }
      }

      if (site.siteType != '') {
        arrR = this.filters.type.options.filter(function (ele) {
          return ele.value == site.siteType
        })

        if (!arrR.length) {
          this.filters.type.options.push({
            label: site.siteTypeDesc,
            value: site.siteType
          })
        }
      }

      if (site.siteCategory != '') {
        arrR = this.filters.category.options.filter(function (ele) {
          return ele.value == site.siteCategory
        })

        if (!arrR.length) {
          this.filters.category.options.push({
            label: site.siteCategoryDesc,
            value: site.siteCategory
          })
        }
      }

      if (site.siteFeatures != '') {
        const featureArray = site.siteFeatures.split(',')
        const featureDescArray = site.siteFeaturesDesc.split(',')

        featureArray.forEach((feature, index) => {
          arrR = this.filters.features.options.filter(function (ele) {
            return ele.value == feature
          })

          if (!arrR.length) {
            this.filters.features.options.push({
              label: featureDescArray[index],
              value: feature
            })
          }
        })
      }

      if (site.siteLoop != '') {
        arrR = this.filters.loop.options.filter(function (ele) {
          return ele.value == site.siteLoop
        })

        if (!arrR.length) {
          this.filters.loop.options.push({
            label: site.siteLoopDesc,
            value: site.siteLoop
          })
        }
      }
    })

    for (let filter in this.filters) {
      this.filters[filter].options.sort((a, b) => {
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1
        return 0
      })
    }

    this.setSelectedFilters()
    this.onSearch(true)
  },
  mounted() {
    this.setGridHeight()
    this.initializeMap()
    this.extendMapHeight()
  },
  watch: {},
  unmounted() {
    window.removeEventListener('resize', this.onResizeWindow)
    document.removeEventListener('orientationchange', this.onResizeWindow)
    document.removeEventListener('touchstart', this.removeHighlight)
  },

  methods: {
    initLayoutConfig() {
      const windowWidth = document.documentElement.clientWidth
      //Should there be a map on the screen
      if (!this.$props.locationcoordinates) {
        this.hasMap = false
        this.mapOpen = false
      } else this.hasMap = true

      //set layout
      if (windowWidth > config.maxTabletWidth) {
        this.primaryState = 'desktop'
        if (this.hasMap) {
          this.secondaryState = 'Condense'
          this.mapOpen = true
        } else {
          this.secondaryState = 'Expand'
          this.mapOpen = false
        }
      } else {
        this.primaryState = 'mobile'
        this.mapOpen = false
        if (windowWidth > config.maxMobileWidth) this.secondaryState = 'Big'
        else this.secondaryState = 'Small'
      }

      //set daysToShow and daysToMove
      this.daysToMove =
        config[this.primaryState + this.secondaryState].daysToMove
      this.daysToShow =
        config[this.primaryState + this.secondaryState].daysToShow
    },

    changeLayout() {
      const windowWidth = document.documentElement.clientWidth
      if (windowWidth <= config.maxTabletWidth) {
        if (this.hasMap && this.primaryState !== 'mobile') {
          this.mapOpen = false
          map.removeControl(fullScreenControl)
        }
        this.primaryState = 'mobile'
        if (windowWidth > config.maxMobileWidth) this.secondaryState = 'Big'
        else this.secondaryState = 'Small'
      } else {
        if (this.primaryState === 'desktop') {
          if (this.secondaryState === 'Expand') {
            this.secondaryState = 'Condense'
            this.mapOpen = true
          } else {
            this.secondaryState = 'Expand'
            this.mapOpen = false
          }
        } else {
          if (this.hasMap) {
            this.secondaryState = 'Condense'
            this.mapOpen = true
            map.addControl(fullScreenControl)
          } else {
            this.secondaryState = 'Expand'
            this.mapOpen = false
          }
        }
        this.primaryState = 'desktop'
      }

      this.daysToShow =
        config[this.primaryState + this.secondaryState].daysToShow
      this.daysToMove =
        config[this.primaryState + this.secondaryState].daysToMove
      this.fetchSiteData(true)
    },

    initializeMap() {
      if (!this.hasMap) return

      const lat = this.$props.locationcoordinates.split(',')[0]
      const long = this.$props.locationcoordinates.split(',')[1]

      mapboxgl.accessToken =
        'pk.eyJ1IjoiZGlyZWN0b3JzdGVjaDEyIiwiYSI6ImNseW9qMDduZzBobjUyanB3NXFjajlncTEifQ.61VJ9JbR8rDUPPwdTbKf4Q'
      map = new mapboxgl.Map({
        container: 'websiterentals-map', // container ID
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [long, lat], // starting position [lng, lat]
        zoom: this.mapzoomlevel // starting zoom
      })

      map.addControl(new mapboxgl.NavigationControl(), 'top-left')
      map.addControl(new mapboxgl.ScaleControl())
      fullScreenControl = new mapboxgl.FullscreenControl()

      if (this.primaryState === 'desktop') {
        map.addControl(fullScreenControl)
      }

      this.createMarkers()
    },
    setGridHeight() {
      if (!this.$refs.tableWrapper) return

      this.$refs.tableWrapper.scrollTo({ top: 0 })

      let tableHeight = 250
      const tablePadding = 0
      let rowHeight = 49
      let noRecords = this.recordsToShow

      if (this.filteredSites.length === 0) {
        this.$refs.tableScroll.style.height = tableHeight + 'px'
        this.$refs.tableWrapper.style['padding-bottom'] = tablePadding + 'px'
        this.$refs.tableScroll.classList.add('bottom')
        return
      }

      if (this.$refs.tableRow && this.$refs.tableRow[0]) {
        rowHeight = this.$refs.tableRow[0].clientHeight
      }

      if (this.filteredSites.length <= this.recordsToShow) {
        noRecords = this.filteredSites.length
        tableHeight = this.$refs.tableScroll.style.height =
          this.$refs.tableHead.clientHeight +
          1 +
          noRecords * (rowHeight + 1) +
          'px'
        this.$refs.tableScroll.style.height =
          tableHeight + 1 + noRecords * (rowHeight + 1) + 'px'
        this.$refs.tableScroll.classList.add('bottom')
        this.$refs.tableWrapper.style['padding-bottom'] = tablePadding + 'px'
        return
      }

      // tableheight = headerHeight + border + recordsShown*(rowHeight + recordBorder) + partOfNextRecord
      tableHeight =
        this.$refs.tableHead.clientHeight +
        1 +
        noRecords * (rowHeight + 1) +
        rowHeight / 2
      this.$refs.tableScroll.style.height = tableHeight + 'px'
      if (
        this.$refs.tableWrapper.scrollTop +
          this.$refs.tableWrapper.clientHeight ===
        this.$refs.tableWrapper.scrollHeight
      ) {
        this.$refs.tableScroll.classList.remove('bottom')
      }
      this.$refs.tableWrapper.style['padding-bottom'] = '55px'
    },

    scrollTop() {
      this.$refs.tableWrapper.scrollTo({ top: 0, behavior: 'smooth' })
    },

    onScroll() {
      if (
        this.$refs.tableWrapper.scrollTop +
          this.$refs.tableWrapper.clientHeight ===
        this.$refs.tableWrapper.scrollHeight
      ) {
        this.$refs.tableScroll.classList.add('bottom')
      } else {
        this.$refs.tableScroll.classList.remove('bottom')
      }
    },

    extendMapHeight() {
      const windowWidth = document.documentElement.clientWidth

      if (this.hasMap) {
        if (this.secondaryState !== 'Condense' && this.extendHeight) {
          this.extendHeight = false
          setTimeout(() => {
            map.resize()
          }, 100)
          return
        }
        if (
          this.extendHeight &&
          this.secondaryState === 'Condense' &&
          (windowWidth > 1109 || windowWidth <= 990)
        ) {
          this.extendHeight = false
          setTimeout(() => {
            map.resize()
          }, 100)
          return
        }
        if (
          !this.extendHeight &&
          this.secondaryState === 'Condense' &&
          windowWidth <= 1109 &&
          windowWidth > 990
        ) {
          this.extendHeight = true
          setTimeout(() => {
            map.resize()
          }, 100)
          return
        }
      }
    },

    onResizeWindow() {
      const windowWidth = document.documentElement.clientWidth

      this.extendMapHeight()

      if (
        windowWidth >= config.maxTabletWidth &&
        this.primaryState === 'desktop'
      )
        return
      if (
        windowWidth <= config.maxTabletWidth &&
        windowWidth > config.maxMobileWidth &&
        this.primaryState + this.secondaryState === 'mobileBig'
      )
        return
      if (
        windowWidth <= config.maxMobileWidth &&
        this.primaryState + this.secondaryState === 'mobileSmall'
      )
        return

      this.changeLayout()
    },

    buildData() {
      const layerData = []

      this.filteredSites.forEach((site) => {
        if (site.coordinates) {
          const lat = site.coordinates.split(',')[0]
          const long = site.coordinates.split(',')[1]
          const siteStatuses = site.dates.filter((d) => d.status === 'A')
          const siteStatus =
            site.dates.length != 0 && site.dates.length === siteStatuses.length
              ? 'Available'
              : siteStatuses.length != 0
              ? 'Partially Available'
              : 'Unavailable'
          const tempFeatures =
            site.siteFeaturesDesc === ''
              ? ''
              : site.siteFeaturesDesc.length > 120
              ? site.siteFeaturesDesc.substring(0, 120) + '...'
              : site.siteFeaturesDesc

          layerData.push({
            id: site.siteId,
            type: 'Feature',
            properties: {
              title: site.siteCode,
              icon:
                (site.iconType === undefined
                  ? ''
                  : site.iconType.toLowerCase().replace(/-/g, '')) +
                '-' +
                siteStatus.toLowerCase().replace(/ /g, ''),
              status: siteStatus,
              description:
                '<p style="padding-right:22px;"><strong>' +
                site.siteDescription +
                ' - ' +
                site.siteCode +
                '</strong></p>' +
                (site.siteImage === ''
                  ? ''
                  : '<p><img alt="' +
                    site.siteDescription +
                    '" class="image" src="' +
                    this.imagePath +
                    site.siteImage +
                    '"></p>') +
                (site.siteLoopDesc === ''
                  ? ''
                  : '<p><strong>Loop:</strong> ' + site.siteLoopDesc + '</p>') +
                (tempFeatures === ''
                  ? ''
                  : '<p><strong>Features:</strong> ' +
                    tempFeatures.replace(/,/g, ', ') +
                    '</p>')
            },
            geometry: {
              type: 'Point',
              coordinates: [long, lat]
            }
          })
        }
      })

      return layerData
    },
    createMarkers() {
      const images = [
        {
          url: this.imagePath + 'boat-unavailable.png',
          id: 'boat-unavailable'
        },
        {
          url: this.imagePath + 'boat-partial.png',
          id: 'boat-partiallyavailable'
        },
        { url: this.imagePath + 'boat-available.png', id: 'boat-available' },
        {
          url: this.imagePath + 'cabin-unavailable.png',
          id: 'cabin-unavailable'
        },
        {
          url: this.imagePath + 'cabin-partial.png',
          id: 'cabin-partiallyavailable'
        },
        { url: this.imagePath + 'cabin-available.png', id: 'cabin-available' },
        {
          url: this.imagePath + 'leanto-unavailable.png',
          id: 'leanto-unavailable'
        },
        {
          url: this.imagePath + 'leanto-partial.png',
          id: 'leanto-partiallyavailable'
        },
        {
          url: this.imagePath + 'leanto-available.png',
          id: 'leanto-available'
        },
        { url: this.imagePath + 'pin-unavailable.png', id: 'pin-unavailable' },
        {
          url: this.imagePath + 'pin-partial.png',
          id: 'pin-partiallyavailable'
        },
        { url: this.imagePath + 'pin-available.png', id: 'pin-available' },
        { url: this.imagePath + 'rv-unavailable.png', id: 'rv-unavailable' },
        { url: this.imagePath + 'rv-partial.png', id: 'rv-partiallyavailable' },
        { url: this.imagePath + 'rv-available.png', id: 'rv-available' },
        {
          url: this.imagePath + 'tent-unavailable.png',
          id: 'tent-unavailable'
        },
        {
          url: this.imagePath + 'tent-partial.png',
          id: 'tent-partiallyavailable'
        },
        { url: this.imagePath + 'tent-available.png', id: 'tent-available' }
      ]

      images.forEach((img) => {
        map.loadImage(img.url, function (error, res) {
          map.addImage(img.id, res)
        })
      })

      let currentID = null

      map.on('load', () => {
        map.addSource('sites', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection'
          },
          cluster: true,
          clusterMaxZoom: 17, // Max zoom to cluster points on
          clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
        })

        map.addLayer({
          id: 'clusters',
          type: 'circle',
          source: 'sites',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': '#206a95',
            'circle-radius': 20
          }
        })

        map.addLayer({
          id: 'cluster-count',
          type: 'symbol',
          source: 'sites',
          filter: ['has', 'point_count'],
          layout: {
            'text-field': ['get', 'point_count_abbreviated'],
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-size': 14
          },
          paint: {
            'text-color': '#FFF'
          }
        })

        map.addLayer({
          id: 'sites',
          type: 'symbol',
          source: 'sites',
          layout: {
            'visibility': 'visible',
            'icon-image': ['get', 'icon'],
            'icon-allow-overlap': true,
            'text-allow-overlap': true,
            'text-field': ['get', 'title'],
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-size': 12,
            'text-offset': [0, 1.75],
            'text-anchor': 'top'
          },
          paint: {
            'text-color': [
              'case',
              ['boolean', ['feature-state', 'hover'], false],
              '#d08039',
              '#000'
            ]
          }
        })

        const popup = new mapboxgl.Popup({ offset: 25 })

        map.on('click', 'sites', (e) => {
          const coordinates = e.features[0].geometry.coordinates.slice()
          const description =
            e.features[0].properties.description +
            '<p><strong>Status:</strong> ' +
            e.features[0].properties.status +
            '</p><p>' +
            '<a href="' +
            this.baseHref +
            'iteminfo.html?Module=RN&FMID=' +
            e.features[0].id +
            (this.checkInDate !== null
              ? '&CheckInDate=' + this.checkInDate
              : '') +
            (this.checkOutDate !== null
              ? '&CheckOutDate=' + this.checkOutDate
              : '') +
            '" aria-label="Additional Details">Additional Details</a>' +
            '</p>'
          const currentID = e.features[0].id
          const tableWrapper = this.$refs.tableWrapper
          const filteredSites = this.filteredSites

          // Ensure that if the map is zoomed out such that multiple
          // copies of the feature are visible, the popup appears
          // over the copy being pointed to.
          if (
            ['mercator', 'equirectangular'].includes(map.getProjection().name)
          ) {
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
              coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
            }
          }

          switch (this.primaryState) {
            case 'mobile': {
              const divElement = document.createElement('div')
              const assignBtn = document.createElement('div')

              assignBtn.innerHTML = `<button id="websiterentals-check-availability" type="button" aria-label="Check Availability" class="button primary">Check Availability</button>`
              divElement.innerHTML = `<div> ${description} </div>`
              divElement.appendChild(assignBtn)

              const filteredSites = this.filteredSites

              assignBtn.addEventListener('click', () => {
                this.removePopup()
                this.openMap()
                this.scrollToId(tableWrapper, filteredSites, currentID)
                document
                  .getElementById('websiterentals-site' + currentID)
                  .classList.add('highlight')
                highlightedSite = currentID
              })

              popup.setLngLat(coordinates).setDOMContent(divElement).addTo(map)

              this.filteredSites.forEach((site) => {
                document
                  .getElementById('websiterentals-site' + site.siteId)
                  .classList.remove('highlight')
                map.removeFeatureState({ source: 'sites', id: site.siteId })
              })

              if (currentID != null) {
                document
                  .getElementById('websiterentals-site' + currentID)
                  .classList.add('highlight')
                map.setFeatureState(
                  { source: 'sites', id: currentID },
                  { hover: true }
                )
              }

              break
            }

            default: {
              this.scrollToId(tableWrapper, filteredSites, currentID)
              popup.setLngLat(coordinates).setHTML(description).addTo(map)
              break
            }
          }
        })

        map.on('mouseenter', 'sites', (e) => {
          if (e.features.length > 0) {
            map.getCanvas().style.cursor = 'pointer'

            currentID = e.features[0].id
            if (currentID != null) {
              document
                .getElementById('websiterentals-site' + currentID)
                .classList.add('highlight')

              map.setFeatureState(
                { source: 'sites', id: currentID },
                { hover: true }
              )
            }
          }
        })

        map.on('mouseleave', 'sites', () => {
          map.getCanvas().style.cursor = ''

          if (currentID != null) {
            document
              .getElementById('websiterentals-site' + currentID)
              .classList.remove('highlight')

            map.removeFeatureState({ source: 'sites', id: currentID })

            currentID = null
          }
        })
      })

      return
    },

    removeHighlight() {
      if (highlightedSite && this.primaryState === 'mobile') {
        document
          .getElementById('websiterentals-site' + highlightedSite)
          .classList.remove('highlight')
        highlightedSite = null
      }
    },

    scrollToId(tableWrapper, filteredSites, currentID) {
      if (!currentID) return
      const index = filteredSites.findIndex((site) => {
        return site.siteId === currentID
      })
      tableWrapper.scrollTo({ top: 49 * index, behavior: 'smooth' })
    },

    updateMarkers() {
      if (!map) return

      const mapSource = map.getSource('sites')

      if (mapSource) {
        const layerData = this.buildData()

        mapSource.setData({
          type: 'FeatureCollection',
          features: layerData
        })
      } else {
        this.updateSource = setTimeout(() => {
          this.updateMarkers()
        }, 1000)
      }

      return
    },
    removePopup() {
      if (!this.hasMap) return

      const popup = document.getElementsByClassName('mapboxgl-popup')
      if (popup.length) popup[0].remove()

      return
    },
    setSelectedFilters() {
      let selectedArray

      if (this.rentalclass) {
        selectedArray = this.rentalclass.split(',')
        selectedArray.forEach((opt) => {
          this.filters.class.options.forEach((element) => {
            if (element.value === opt) {
              this.filters.class.values.push(opt)
              return
            }
          })
        })
      }

      if (this.rentaltype) {
        selectedArray = this.rentaltype.split(',')
        selectedArray.forEach((opt) => {
          this.filters.type.options.forEach((element) => {
            if (element.value === opt) {
              this.filters.type.values.push(opt)
              return
            }
          })
        })
      }

      if (this.rentalcategory) {
        selectedArray = this.rentalcategory.split(',')
        selectedArray.forEach((opt) => {
          this.filters.category.options.forEach((element) => {
            if (element.value === opt) {
              this.filters.category.values.push(opt)
              return
            }
          })
        })
      }

      if (this.rentalfeatures) {
        selectedArray = this.rentalfeatures.split(',')
        selectedArray.forEach((opt) => {
          this.filters.features.options.forEach((element) => {
            if (element.value === opt) {
              this.filters.features.values.push(opt)
              return
            }
          })
        })
      }

      if (this.rentalsiteloop) {
        selectedArray = this.rentalsiteloop.split(',')
        selectedArray.forEach((opt) => {
          this.filters.loop.options.forEach((element) => {
            if (element.value === opt) {
              this.filters.loop.values.push(opt)
              return
            }
          })
        })
      }

      return
    },

    onFilterChange() {
      if (this.primaryState === 'mobile') return

      this.onSearch(false)
    },

    onMobileSearch() {
      this.noActiveFilters = 0

      if (this.filters.class.values.length > 0) this.noActiveFilters += 1
      if (this.filters.type.values.length > 0) this.noActiveFilters += 1
      if (this.filters.category.values.length > 0) this.noActiveFilters += 1
      if (this.filters.features.values.length > 0) this.noActiveFilters += 1
      if (this.filters.loop.values.length > 0) this.noActiveFilters += 1

      this.onSearch(false)
      this.$refs.filterGroup.classList.add('hidden')
    },

    onMobileReset() {
      this.filters.class.values = []
      this.filters.type.values = []
      this.filters.category.values = []
      this.filters.features.values = []
      this.filters.loop.values = []

      this.noActiveFilters = 0
      this.$refs.filterGroup.classList.add('hidden')
      this.onSearch(false)
    },

    onSearch(dateChange) {
      this.filteredSites = this.sites
        .filter((site) => {
          let skipSite = false

          if (
            this.filters.class.values.length &&
            !this.filters.class.values.find((value) => value === site.siteClass)
          ) {
            return false
          }

          if (
            this.filters.type.values.length &&
            !this.filters.type.values.find((value) => value === site.siteType)
          ) {
            return false
          }

          if (
            this.filters.category.values.length &&
            !this.filters.category.values.find(
              (value) => value === site.siteCategory
            )
          ) {
            return false
          }

          if (this.filters.features.values.length) {
            this.filters.features.values.forEach((feature) => {
              const featureArr = site.siteFeatures.split(',')

              if (!featureArr.find((value) => value === feature)) {
                skipSite = true
              }
            })
          }

          if (
            this.filters.loop.values.length &&
            !this.filters.loop.values.find((value) => value === site.siteLoop)
          ) {
            return false
          }

          if (skipSite) {
            return false
          }

          if (
            this.keywordSearch != '' &&
            !site.siteCode
              .toLowerCase()
              .includes(this.keywordSearch.toLowerCase())
          ) {
            return false
          }

          return true
        })
        .map((s) => {
          return Object.assign({}, s, {
            dates: []
          })
        })

      this.removePopup()
      this.setSiteSelections()
      this.fetchSiteData(dateChange)
      this.setGridHeight()
    },
    changeData(newFilteredSites) {
      this.filteredSites = newFilteredSites
      this.updateMarkers()

      return
    },
    onMouseOverSite(siteId) {
      document
        .getElementById('websiterentals-site' + siteId)
        .classList.add('highlight')
      this.removeHighlight()

      if (map)
        map.setFeatureState({ source: 'sites', id: siteId }, { hover: true })
    },
    onMouseOutSite(siteId) {
      document
        .getElementById('websiterentals-site' + siteId)
        .classList.remove('highlight')
      this.removeHighlight()

      if (map) map.removeFeatureState({ source: 'sites', id: siteId })
    },
    onClickCode(site) {
      if (!site.beginDate && this.checkInDate && this.checkOutDate) {
        const tempInDate = new Date(this.checkInDate)
        const tempOutDate = new Date(this.checkOutDate)

        if (tempInDate < tempOutDate) {
          const inColumn = this.displayedDates.indexOf(
            this.displayedDates.find((d) => d.dateTime === tempInDate.getTime())
          )

          if (inColumn != undefined) this.onClickGrid(site, inColumn)
        }
      }

      return
    },
    onClickGrid(site, column) {
      if (this.processing) return

      let removed = false
      let newBeginDate = null
      let newEndDate = null

      if (!site.beginDate) {
        if (site.dates[column].status !== 'A') return
        if (column === this.daysToShow - 1) {
          const tempDate = new Date(this.beginDate)

          column = column - 1
          tempDate.setDate(tempDate.getDate() + 1)
          this.onCheckInDate(tempDate)
        }

        newBeginDate = this.displayedDates[column].dateTime

        this.removePopup()

        if (this.checkInDate && this.checkOutDate) {
          const tempInDate = new Date(this.checkInDate)
          const tempOutDate = new Date(this.checkOutDate)

          if (
            tempInDate < tempOutDate &&
            newBeginDate === tempInDate.getTime()
          ) {
            newEndDate = tempOutDate.getTime()
          } else {
            newEndDate = this.displayedDates[column + 1].dateTime
          }
        } else {
          newEndDate = this.displayedDates[column + 1].dateTime
        }
      } else if (site.endDate === this.displayedDates[column].dateTime) {
        newBeginDate = site.beginDate
        newEndDate = site.endDate
        removed = true
      } else if (site.endDate < this.displayedDates[column].dateTime) {
        newBeginDate = site.beginDate
        newEndDate = this.displayedDates[column].dateTime
      } else if (site.beginDate > this.displayedDates[column].dateTime) {
        newBeginDate = this.displayedDates[column].dateTime
        newEndDate = site.endDate
      }

      this.makeSelection(site, removed, newBeginDate, newEndDate)
    },
    updateDisplayedDates() {
      const daysOfWeek = [
        { short: 'Sun', long: 'Sunday' },
        { short: 'Mon', long: 'Monday' },
        { short: 'Tue', long: 'Tuesday' },
        { short: 'Wed', long: 'Wednesday' },
        { short: 'Thu', long: 'Thursday' },
        { short: 'Fri', long: 'Friday' },
        { short: 'Sat', long: 'Saturday' }
      ]
      const monthsOfYear = [
        { short: 'Jan', long: 'January' },
        { short: 'Feb', long: 'February' },
        { short: 'Mar', long: 'March' },
        { short: 'Apr', long: 'April' },
        { short: 'May', long: 'May' },
        { short: 'June', long: 'June' },
        { short: 'July', long: 'July' },
        { short: 'Aug', long: 'August' },
        { short: 'Sept', long: 'September' },
        { short: 'Oct', long: 'October' },
        { short: 'Nov', long: 'November' },
        { short: 'Dec', long: 'December' }
      ]
      const begDate = new Date(this.beginDate)
      this.monthColumns = []

      this.displayedDates = [
        {
          dateString: getFormattedDate(begDate),
          dateTime: begDate.getTime(),
          descDay: daysOfWeek[begDate.getDay()].short,
          descDayLong: daysOfWeek[begDate.getDay()].long,
          descDate: begDate.getDate(),
          descMonth: monthsOfYear[begDate.getMonth()].long
        }
      ]
      this.monthColumns.push({
        desc: monthsOfYear[begDate.getMonth()].short,
        long: monthsOfYear[begDate.getMonth()].long,
        span: 1
      })

      for (let day = 1; day <= this.daysToShow - 1; day++) {
        begDate.setDate(begDate.getDate() + 1)
        this.displayedDates.push({
          dateString: getFormattedDate(begDate),
          dateTime: begDate.getTime(),
          descDay: daysOfWeek[begDate.getDay()].short,
          descDayLong: daysOfWeek[begDate.getDay()].long,
          descDate: begDate.getDate(),
          descMonth: monthsOfYear[begDate.getMonth()].long
        })
        const monthExists = this.monthColumns.find(
          (m) => m.desc === monthsOfYear[begDate.getMonth()].short
        )

        if (monthExists) {
          monthExists.span = monthExists.span + 1
        } else {
          this.monthColumns.push({
            desc: monthsOfYear[begDate.getMonth()].short,
            long: monthsOfYear[begDate.getMonth()].long,
            span: 1
          })
        }
      }
    },
    onPrevNext(days) {
      if (!days) {
        return
      }

      const tempCurrent = new Date(this.currentDate)
      let newBeginDate = new Date(this.beginDate)
      newBeginDate.setDate(newBeginDate.getDate() + days)

      if (newBeginDate < tempCurrent) {
        newBeginDate = this.currentDate
      } else {
        newBeginDate = getFormattedDate(newBeginDate)
      }

      if (this.beginDate !== newBeginDate) {
        this.beginDate = newBeginDate
        this.fetchSiteData(true)
      }

      this.setSiteRentalsCookie()

      return days
    },
    onExpand() {
      if (this.hasMap) {
        this.changeLayout()
        this.extendMapHeight()
      }
    },

    openMap() {
      if (this.hasMap) this.mapOpen = !this.mapOpen
    },

    onSort(column) {
      if (column === 'code') {
        this.sortOption =
          this.sortOption === 'codeascending'
            ? 'codedescending'
            : 'codeascending'
      } else if (column === 'loop') {
        this.sortOption =
          this.sortOption === 'loopascending'
            ? 'loopdescending'
            : 'loopascending'
      } else {
        this.sortOption =
          this.sortOption === column.toString() + 'ascending'
            ? column.toString() + 'descending'
            : column.toString() + 'ascending'
      }

      return
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../assets/css/abstract/variables';
@import '../../assets/css/abstract/mixins';
@import '../../assets/css/components/table';

#websiterentals {
  #websiterentals-commentcard {
    margin-bottom: 0px;
  }

  #websiterentals-filters {
    display: flex;
  }

  .filter-group {
    border: 1px solid hsla(0, 0%, 75%, 0.5);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    margin-top: 16px;

    .header.group__header {
      display: block;
    }

    .group__inner {
      padding: 16px;
      background: #fff;
    }
  }

  .filter-group.mobile {
    border: none;
    box-shadow: none;
    -webkit-box-shadow: none;

    .header.group__header {
      z-index: 101;
    }

    .header.group__header.hidden {
      display: none;
    }

    .group__inner {
      z-index: 100;
    }
  }

  .filter-group.hidden {
    .header.group__header {
      z-index: 98;
    }

    .group__inner {
      display: none;
    }
  }

  .search-criteria {
    display: block;
    width: 19%;
    margin-right: 1%;
    float: left;

    label {
      width: 100%;
    }
  }

  #websiterentals-grid {
    display: flex;
    flex-flow: column;
    width: 55%;
    float: left;

    #websiterentals-controls {
      width: 100%;
      float: left;
      margin-bottom: 10px;

      #websiterentals-controls-top.extendHeight {
        display: flex;
        flex-direction: column;
        #websiterentals-controls-top-left {
          display: inline-flex;
          justify-content: space-between;
        }
      }

      #websiterentals-controls-top {
        width: 100%;
        padding: 12px;
        margin-bottom: 12px;
        float: left;
        background: @background-color;
        border-radius: 4px;
        border: solid 1px rgba(192, 192, 192, 0.5);

        #websiterentals-controls-top-left {
          float: left;

          .datepicker-wrap {
            float: left;
            width: 130px;
            margin-right: 12px;
          }

          .fillin-wrap {
            float: left;
            margin-right: 12px;
            width: 150px;

            .fillin-label {
              width: 100%;
            }
          }

          .fillin-wrap.extendHeight {
            width: 177px;
            margin-right: 0px;
          }
        }

        #websiterentals-controls-top-right {
          float: right;

          #websiterentals-expand,
          #websiterentals-condense {
            text-align-last: center;
            margin-left: 0;
            margin-right: 0;
            margin-top: 27px;
            padding: 0 12px 0 30px;
            float: right;
            position: relative;
          }

          #websiterentals-expand.extendHeight {
            margin-top: 12px;
          }
        }
      }

      #websiterentals-controls-bottom {
        float: left;
        width: 100%;

        #websiterentals-controls-left {
          float: left;

          button {
            margin-left: 0;
            margin-right: 12px;
            padding: 0 10px 0 30px;
            position: relative;
          }
        }

        #websiterentals-controls-right {
          float: right;

          button {
            margin-left: 12px;
            margin-right: 0;
            padding: 0 12px;
          }
        }
      }

      .primary {
        .default-focus-indicator(3px, #005486);
        background-color: #015c8e;
        border-color: #015c8e;
        color: #fff;

        &:hover,
        &:focus {
          background-color: #005486;
        }
      }

      .icon {
        position: absolute;
        top: 25%;
        left: 5px;
        width: 16px;
        height: 16px;

        .svg-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -8px;
          margin-left: -5px;
        }
      }
    }
  }

  #websiterentals-grid.expanded {
    width: 100%;
  }

  #websiterentals-map.extendHeight {
    height: 801px !important;
  }

  #websiterentals-map {
    margin-left: 1%;
    float: left;
    position: relative;
    visibility: hidden;
  }

  #websiterentals-map.visible {
    visibility: visible;
    width: 44%;
    height: 752px;
  }

  #websiterentals-map.mobileMap {
    width: 100%;
    height: calc(100% - 60px);
    margin-left: 6px;
    position: fixed;
    top: 60px;
    left: -6px;
    z-index: 5;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  #websiterentals-map.mobileMap.selected {
    height: calc(100% - 110px);
  }
}

.mobileGroup {
  width: calc(100% + 32px);
  margin-left: -16px;
  padding: 0px;
  border: 0px;
  box-shadow: none;
  background: transparent;
}

.mapboxgl-ctrl-top-right {
  left: 0 !important;
  right: auto !important;
}

.mapButton,
.mapButtonClose {
  position: fixed;
  z-index: 6;
  align-items: center;
  justify-content: center;
}

.mapButton:hover,
.mapButtonClose:hover {
  cursor: pointer;
}

.mapButton {
  bottom: 15px;
  right: calc(50% - 67.5px);
  width: 135px;
  height: 48px;
  background-color: #46545ff0;
  color: #fff;
  display: inline-flex;

  &:focus-visible {
    outline: 8px double black;
    outline-offset: -6px;
    box-shadow: 0px 0px 0px 3px white inset;
  }
}

.mapButtonClose {
  top: 70px;
  right: 10px;
  width: 28px;
  height: 28px;
  background-color: #fff;
  background-position: 50%;
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  padding: 0px 8px;
}

.mapButton.selected {
  bottom: 65px;
}

#websiterentals-table-scroll {
  width: 100%;
  position: relative;
}

#websiterentals-table-scroll::after {
  content: '';
  position: absolute;
  z-index: 3;
  left: 0px;
  right: 0px;
  height: 15%;
  bottom: 0px;
  background: linear-gradient(180deg, transparent 0%, rgb(255, 255, 255) 100%);
  pointer-events: none;
}

#websiterentals-table-scroll.bottom::after {
  display: none;
}

#websiterentals-table-top-button {
  .default-focus-indicator(2px, #005486);
  position: absolute;
  bottom: 18px;
  right: 15px;
  z-index: 4;
  background-color: #005486dd;
  border-color: #005486dd;
  color: white;
  border-radius: 50%;
  height: 45px;
  width: 45px;

  span {
    margin-left: -6.5px;
  }

  &:hover,
  &:focus {
    background-color: #005486;
  }
}

#websiterentals-table-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 55px;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;

  #websiterentals-empty-message {
    position: absolute;
    top: 50%;
    width: 100%;
    text-align: center;
  }
}

#websiterentals-table-wrapper::-webkit-scrollbar {
  display: none;
}

.rental-calendar-table {
  width: 100%;
  font-size: 100%;
  border-collapse: separate;

  thead {
    position: sticky;
    top: 0;
    z-index: 3;
  }

  tr {
    overflow: visible;
  }

  tbody tr.highlight {
    .primary.info-cell {
      background: #015c8e;

      a,
      a:link,
      a:active a:hover,
      a:focus {
        background-image: url('../../assets/img/icons/glyph/24/more-vert-white.svg');
      }

      button {
        color: #fff;
      }
    }
  }

  th:not(.site-cell) {
    overflow: hidden;
    color: #272c33;
    font-weight: 600;
    background: #fff;
    font-size: @font-size-14px;
    position: relative;
    width: 49px;
    height: 40px;
    padding: 0;
    text-align: center;
    line-height: 1.1;
  }

  th.primary:not(.site-cell) {
    background: #015c8e;
    color: #fff;
    width: 88px;

    &:first-child {
      border-right: solid 1px #fff;
    }

    button {
      background: transparent;
      text-align: center;
      position: relative;
      width: 100%;
      height: 100%;
      color: #fff;
      cursor: pointer;

      &.ascending {
        background: center right 6px no-repeat
          url('../../assets/img/icons/glyph/12/triangle-down-white.svg');
        padding-right: 14px;

        &:focus-visible {
          background: #ffffff center right 6px no-repeat
            url('../../assets/img/icons/glyph/12/triangle-down-black.svg');
        }
      }

      &.descending {
        background: center right 6px no-repeat
          url('../../assets/img/icons/glyph/12/triangle-up-white.svg');
        padding-right: 14px;

        &:focus-visible {
          background: #ffffff center right 6px no-repeat
            url('../../assets/img/icons/glyph/12/triangle-up-black.svg');
        }
      }

      &:hover,
      &:focus {
        background-color: #005486;
      }

      &:focus-visible {
        background-color: #ffffff;
        color: black;
        outline: 2px solid #005486;
        outline-offset: -3px;
      }
    }
  }

  th.day {
    background: #46545f;
    color: #fff;
    border-right: solid 1px rgba(192, 192, 192, 0.5);
    min-width: 24px;

    button {
      background: transparent;
      text-align: center;
      position: relative;
      width: 100%;
      height: 100%;
      color: #fff;
      font-size: 13px;
      cursor: pointer;

      &.ascending {
        background: center right 3px no-repeat
          url('../../assets/img/icons/glyph/12/triangle-down-white.svg');
        padding-right: 14px;

        &:focus-visible {
          background: #ffffff center right 3px no-repeat
            url('../../assets/img/icons/glyph/12/triangle-down-black.svg');
        }
      }

      &.descending {
        background: center right 3px no-repeat
          url('../../assets/img/icons/glyph/12/triangle-up-white.svg');
        padding-right: 14px;

        &:focus-visible {
          background: #ffffff center right 3px no-repeat
            url('../../assets/img/icons/glyph/12/triangle-up-black.svg');
        }
      }

      &:hover,
      &:focus {
        background-color: #2c353c;
      }

      &:focus-visible {
        background-color: #fff;
        outline: 2px solid #2c353c;
        color: black;
      }
    }
  }

  th.month {
    border-top: solid 1px @controls-border-color;
    border-right: solid 1px @controls-border-color;
  }

  th.blank {
    border-right: 1px solid @controls-border-color;
    background: #fff;
  }

  th.blank.mobileMap {
    background: #f7f7f7;
  }

  td,
  .site-cell {
    background: #fff;
    color: #272c33;
    font-size: @font-size-14px;
    height: 49px;
    padding: 0;
    text-align: center;
    vertical-align: middle;

    a,
    a:link,
    a:active,
    a:hover {
      font-size: @font-size-14px;
    }

    a:focus-visible {
      outline: 2px solid #000;
    }

    a.fill-cell {
      width: 100%;
    }

    &.no-wrap {
      white-space: nowrap;
    }

    &.button-cell {
      &--more {
        overflow: visible;
      }
    }

    button {
      background: transparent;
      text-align: center;
      position: relative;
      width: 100%;
      height: 100%;
      cursor: pointer;
      border-right: 1px solid #015c8e;
      border-bottom: 1px solid #015c8e;

      .icon {
        position: absolute;
        top: 2px;
        right: -5px;
        width: 16px;
        height: 16px;
        background: #e60013;
        border-radius: 100%;
        z-index: 2;

        .svg-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -5px;
          margin-left: -5px;
        }
      }

      &:focus-visible {
        outline: 2px solid #000;
        border-right: 0;
        border-bottom: 0;
      }
    }
  }

  .day-container {
    display: contents;
  }

  .day {
    overflow: visible;
  }

  .primary {
    color: #015c8e;
  }

  .available {
    background-color: #e6f2f8;
    color: #015c8e;
    font-weight: 700;
  }

  .unavailable,
  .reserved {
    color: #272c33;
  }

  .day.available:hover,
  .day.available:focus {
    background-color: #cfdadf;
  }

  .day.selected {
    // using font-size 0 here to get rid of the contrast ratio error for these cells (the status is displayed when the cell is selected but it has the same color as the background so it's not visible anyway)
    font-size: 0;
    background-color: #015c8e;
    color: #015c8e;
    border-color: #015c8e;
    box-shadow: 1px 0 0 #015c8e;
  }

  .day.selected:hover,
  .day.selected:focus {
    background-color: #015380;
    color: #015380;
  }

  .day.selected.begin {
    box-shadow: 1px 0 0 #015c8e, inset 4px 0 0 #000;
  }
  .day.selected.end {
    box-shadow: inset -4px 0 0 #000;
    border-right: none;
  }

  .primary.info-cell {
    display: flex;

    button {
      .default-focus-indicator(-2px, black);
      position: relative;
      border: solid 1px @controls-border-color;
      border-right: none;
      border-top: none;

      span {
        padding-left: 4px;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    button:before {
      content: '&nbsp;';
      visibility: hidden;
    }

    a {
      border-bottom: solid 1px @controls-border-color;
      border-right: solid 1px @controls-border-color;
      border-left: none;
      border-top: none;
    }

    a,
    a:link,
    a:active {
      .default-focus-indicator(-2px, black);
      width: 24px;
      min-width: 24px;
      height: 100%;
      background: left top no-repeat
        url('../../assets/img/icons/glyph/24/more-vert.svg');
      background-position: 50%;
    }
  }

  .primary.info-cell.selected {
    box-shadow: inset 4px 0 0 #015c8e;
    border-left: none;
  }

  .cell-inner {
    display: block;
    font-weight: 400;
  }
}

@media @tablet-down {
  #websiterentals-filters {
    display: block !important;
  }

  .search-criteria {
    width: 100% !important;
    margin-right: 0 !important;
  }

  #websiterentals-grid {
    width: 100% !important;

    #websiterentals-controls {
      #websiterentals-controls-top {
        width: 100% !important;
        display: block !important;

        input {
          width: 100% !important;
        }

        .datepicker-wrap {
          width: 48% !important;
          margin: 0 !important;

          &:first-child {
            margin-right: 4% !important;
          }
        }

        .fillin-wrap {
          width: 100% !important;
          margin: 8px 0 0 0 !important;
        }

        #websiterentals-controls-top-left {
          width: 100%;
        }

        #websiterentals-controls-top-right {
          width: 100%;

          #websiterentals-expand,
          #websiterentals-condense {
            display: none;
          }
        }
      }

      #websiterentals-controls-left {
        width: 100% !important;
        margin-bottom: 4px !important;

        button {
          margin-top: 0 !important;
          margin-right: 0 !important;
        }
      }

      #websiterentals-controls-right {
        width: 100% !important;
        margin-bottom: 2px !important;

        button {
          margin: 0 0 0 2% !important;
          width: 49% !important;
          padding: 0 2px !important;
          line-height: 1;

          &:first-child {
            margin-left: 0 !important;
          }
        }
      }
    }
  }
}
</style>
